<template>
  <div>
    <v-row class="mx-0 mx-md-1 table-bowse-team tabtwotable">
      <!--//* Fnatasy -->
      <!-- <v-col cols="12" md="4" sm="4">
        <base-title-bar
          elevation="3"
          class="text-center table-bowse-team-pro"
          color="blue white--text"
          label="Fantasy"
        />
        <v-list dense elevation="2" rounded-0 rounded-md-1 >
          <v-list-item>

            <v-list-item-content class="text-center">
              <v-list-item-title>
                <p class="body-1 font-weight-bold">
                  FK
                </p>

                <router-link
                  v-for="item in depthChart.FantasyPlayer.FKplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none;"
                  class="body-2"
                >
                  <p>{{ item.FirstName }} {{ item.LastName }}</p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">
                  FQB
                </p>

                <router-link
                  v-for="item in depthChart.FantasyPlayer.FQBplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none;"
                  class="body-2"
                >
                  <p>{{ item.FirstName }} {{ item.LastName }}</p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">
                  FRWR
                </p>
                <router-link
                  v-for="item in depthChart.FantasyPlayer.FRWRplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none;"
                  class="body-2"
                >
                  <p>{{ item.FirstName }} {{ item.LastName }}</p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">
                  FTE
                </p>

                <router-link
                  v-for="item in depthChart.FantasyPlayer.FTEplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none;"
                  class="body-2"
                >
                  <p>{{ item.FirstName }} {{ item.LastName }}</p>
                </router-link>
              </v-list-item-title>
            </v-list-item-content>



            <v-list-item-content class="text-center">
              <v-list-item-title>
                <p class="body-1 font-weight-bold">
                  FLWR
                </p>

                <router-link
                  v-for="item in depthChart.FantasyPlayer.FLWRplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none;"
                  class="body-2"
                >
                  <p>{{ item.FirstName }} {{ item.LastName }}</p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">
                  FRB
                </p>

                <router-link
                  v-for="item in depthChart.FantasyPlayer.FRBplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none;"
                  class="body-2"
                >
                  <p>{{ item.FirstName }} {{ item.LastName }}</p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">
                  FSWR
                </p>

                <router-link
                  v-for="item in depthChart.FantasyPlayer.FSWRplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none;"
                  class="body-2"
                >
                  <p>{{ item.FirstName }} {{ item.LastName }}</p>
                </router-link>
              </v-list-item-title>
            </v-list-item-content>

          </v-list-item>
        </v-list>
      </v-col> -->
      <!--//* Fantasy ends -->

      <!--//* DEF -->
      <v-col cols="12" md="6" sm="6" class="mb-2 px-0 px-md-3">
        <base-title-bar
          elevation="3"
          class="text-center tabtwotablehead"
          label="DEF"
        />
        <v-list dense elevation="2" class="box-shadownon" rounded>
          <v-list-item>
            <!-- 1 -->
            <v-list-item-content class="text-center">
              <v-list-item-title>
                <p class="body-1 font-weight-bold">FS</p>

                <router-link
                  v-for="item in depthChart.DEFPlayer.DEFFSplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">LC</p>

                <router-link
                  v-for="item in depthChart.DEFPlayer.DEFLCBplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">LDE</p>

                <router-link
                  v-for="item in depthChart.DEFPlayer.DEFLDEplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">LDT</p>

                <router-link
                  v-for="item in depthChart.DEFPlayer.DEFLDTplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>
            </v-list-item-content>
            <!-- //todo -->

            <!-- 2-->
            <v-list-item-content class="text-center">
              <v-list-item-title>
                <p class="body-1 font-weight-bold">NB</p>

                <router-link
                  v-for="item in depthChart.DEFPlayer.DEFNBplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">RCB</p>

                <router-link
                  v-for="item in depthChart.DEFPlayer.DEFRCBplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">RDE</p>

                <router-link
                  v-for="item in depthChart.DEFPlayer.DEFRDEplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">SS</p>

                <router-link
                  v-for="item in depthChart.DEFPlayer.DEFSSplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>
            </v-list-item-content>
            <!-- //todo -->
          </v-list-item>
        </v-list>
      </v-col>
      <!--//* DEF ends -->

      <!--//* OFF -->
      <v-col cols="12" md="6" sm="6" class="mb-0 mb-md-2 px-0 px-md-3">
        <base-title-bar
          elevation="3"
          class="text-center font-weight-bold tabtwotablehead"
          label="OFF"
        />
        <v-list dense elevation="2" class="box-shadownon" rounded>
          <v-list-item>
            <!-- 1 -->
            <v-list-item-content class="text-center">
              <v-list-item-title>
                <p class="body-1 font-weight-bold">C</p>

                <router-link
                  v-for="item in depthChart.OFFPlayer.OFFCplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">LG</p>

                <router-link
                  v-for="item in depthChart.OFFPlayer.OFFLGplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">LT</p>

                <router-link
                  v-for="item in depthChart.OFFPlayer.OFFLTplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">LWR</p>

                <router-link
                  v-for="item in depthChart.OFFPlayer.OFFLWRplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">QB</p>

                <router-link
                  v-for="item in depthChart.OFFPlayer.OFFQBplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>
            </v-list-item-content>
            <!-- //todo -->

            <!-- 2-->
            <v-list-item-content class="text-center">
              <v-list-item-title>
                <p class="body-1 font-weight-bold">RB</p>

                <router-link
                  v-for="item in depthChart.OFFPlayer.OFFRBplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">RG</p>

                <router-link
                  v-for="item in depthChart.OFFPlayer.OFFRGplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">RT</p>

                <router-link
                  v-for="item in depthChart.OFFPlayer.OFFRTplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>

              <v-list-item-title>
                <p class="body-1 font-weight-bold">RWR</p>

                <router-link
                  v-for="item in depthChart.OFFPlayer.OFFRWRplayer"
                  :key="item._id"
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  <p class="mb-0 mb-md-3">
                    {{ item.FirstName }} {{ item.LastName }}
                  </p>
                </router-link>
              </v-list-item-title>
            </v-list-item-content>
            <!-- //todo -->
          </v-list-item>
        </v-list>
      </v-col>
      <!--//* OFF ends -->
    </v-row>
  </div>
</template>

<script>
export default {
  name: "nfl-depthchart",
  props: {
    depthChart: {
      type: [Array, Object],
      default: () => [],
    },
  },
};
</script>

<style></style>
